import { getPokelist, getPokemon } from "../services/services";

export const setBlueKey = (key) => async (dispatch) => {
  console.log("blue", key);
  await dispatch({
    type: "SET_BLUE_KEY",
    payload: key,
  });
};
